<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 发票记录
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <el-form class="filter-form" :inline="true" size="small">
          <el-form-item label="玩家账号">
            <el-input v-model.trim="listQuery.account" clearable></el-input>
          </el-form-item>
          <el-form-item label="游戏名称">
            <el-select v-model="listQuery.game_id" filterable remote clearable placeholder="请选择" :remote-method="remoteMethod">
              <el-option v-for="item in gameNameOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请人">
            <el-select v-model="listQuery.admin_id" filterable clearable placeholder="请选择">
              <el-option v-for="item in applicateOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="receiptM2" label="开票人/公司名称">
            <el-input v-model.trim="listQuery.real_name" clearable></el-input>
          </el-form-item>
          <el-form-item v-if="receiptM2" label="邮箱">
            <el-input v-model.trim="listQuery.email" clearable></el-input>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker
              v-model="listQuery.create_time"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
        </el-form>

        <div class="toolbar">
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button type="success" icon="el-icon-plus" @click="addBill">添加发票</el-button>
          <el-button type="warning" icon="el-icon-refresh" @click="resetAll">重置</el-button>
        </div>

        <el-table
          border
          min-height="200"
          max-height="1000"
          v-loading="listLoading"
          :data="tableData"
          style="width: 100%"
          :default-sort="{ prop: 'created_at', order: 'descending' }"
          @sort-change="sortChange"
        >
          <el-table-column prop="created_at" label="申请时间" sortable width="150"></el-table-column>
          <el-table-column prop="account" label="玩家账号"></el-table-column>
          <el-table-column prop="game_name" label="游戏名称"></el-table-column>
          <el-table-column prop="game_server" label="区服"></el-table-column>
          <el-table-column prop="role_name" label="角色名称"></el-table-column>
          <el-table-column prop="total_money" label="总充值金额" sortable></el-table-column>
          <el-table-column prop="admin_name" label="申请人"></el-table-column>
          <el-table-column prop="real_name" :label="receiptM2 ? '开票人/公司名称' : '开票人真实姓名'"></el-table-column>
          <el-table-column v-if="receiptM2" prop="type_name" label="开票类型" width="130"></el-table-column>
          <el-table-column prop="mobile" label="联系手机"></el-table-column>
          <el-table-column prop="email" label="邮箱地址" width="170"></el-table-column>
          <el-table-column v-if="receiptM2" label="证明材料" width="100" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.proof_images_count" type="text" @click="previewProofImages(scope.row)">
                {{ scope.row.proof_images_count }}张
              </el-button>
              <span v-else>0张</span>
            </template>
          </el-table-column>
          <el-table-column prop="billSection" label="发票区间" width="300"></el-table-column>
          <el-table-column prop="remark" label="备注栏" :show-overflow-tooltip="true" width="100"></el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" icon="el-icon-edit" @click="edit(scope.row)">编辑</el-button>
              <el-tooltip v-if="receiptDeleteEnabled && receiptM2 && canDelete" content="删除" placement="top">
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteBill(scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getBill"
        ></pagination>
      </div>
    </div>

    <el-dialog
      :title="popupTitle"
      width="720px"
      center
      :visible.sync="billVisible"
      class="billHandle"
      :close-on-click-modal="addControl"
      @close="closeDialog"
    >
      <el-form ref="billForm" :model="data" :rules="billRules" label-width="190px" v-loading="submitting">
        <el-form-item label="玩家账号" prop="account">
          <el-input v-model.trim="data.account"></el-input>
        </el-form-item>
        <el-form-item label="游戏名称" prop="game_id">
          <el-select v-model="data.game_id" filterable placeholder="请选择">
            <el-option v-for="item in gameOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区服" prop="game_server">
          <el-input v-model.trim="data.game_server"></el-input>
        </el-form-item>
        <el-form-item label="角色名称" prop="role_name">
          <el-input v-model.trim="data.role_name"></el-input>
        </el-form-item>
        <el-form-item label="开票类型" prop="type">
          <el-radio-group v-model="data.type" :disabled="receiptM2 && check === 0">
            <el-radio :label="1">个人普通发票</el-radio>
            <el-radio :label="2">公司普通发票</el-radio>
            <el-radio v-if="receiptM2" :label="3">公司专用发票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="data.type === 1 ? '开票人真实姓名' : '公司名称'" prop="real_name">
          <el-input v-model.trim="data.real_name"></el-input>
        </el-form-item>
        <el-form-item v-if="receiptM2 && isCompany" label="公司税号" prop="tax_no">
          <el-input v-model.trim="data.tax_no" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item v-if="receiptM2 && isCompany" label="证明材料（最多5张）" prop="proof_images">
          <image-upload
            :img-list="data.proof_images"
            :max="5"
            :multiple="true"
            accept=".jpg,.jpeg,.png,.bmp,.gif"
            @uploading-change="onUploadingChange"
            @upload-state-change="onProofUploadStateChange"
          ></image-upload>
        </el-form-item>
        <el-form-item label="联系手机" prop="mobile">
          <el-input v-model.trim="data.mobile"></el-input>
        </el-form-item>
        <el-form-item label="邮箱地址" prop="email">
          <el-input v-model.trim="data.email"></el-input>
        </el-form-item>
        <el-form-item label="发票开始日期" prop="receipt_time_begin">
          <el-date-picker v-model="data.receipt_time_begin" type="datetime" placeholder="请选择开始日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="发票结束日期" prop="receipt_time_end">
          <el-date-picker v-model="data.receipt_time_end" type="datetime" placeholder="请选择结束日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注栏（原因，申请状态）">
          <el-input type="textarea" v-model="data.remark" :rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="remove">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="sure">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="证明材料" width="720px" :visible.sync="proofVisible">
      <div class="proof-preview">
        <el-image
          v-for="image in previewImages"
          :key="image.id || image.url"
          :src="image.url"
          :preview-src-list="previewImageUrls"
          fit="cover"
        ></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBillApi,
  addBillApi,
  getSingleBillApi,
  submitSingleBillApi,
  deleteBillApi,
  applicationListApi,
  gameListApi,
  searchGameNameApi,
} from '@/api/bill_record.js';
import Pagination from '@/components/pagination/index';
import ImageUpload from '@/components/common/ImageUpload/ImageUpload.vue';

export default {
  name: 'bill_record',
  components: { Pagination, ImageUpload },
  data() {
    return {
      listLoading: false,
      submitting: false,
      uploadingCount: 0,
      proofUploadCanSubmit: true,
      total: 0,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 10,
        account: '',
        game_id: '',
        admin_id: '',
        real_name: '',
        email: '',
        create_time: '',
        order_field: 0,
        order_type: 0,
      },
      data: {
        account: '',
        game_id: '',
        game_server: '',
        role_name: '',
        real_name: '',
        tax_no: '',
        proof_images: [],
        mobile: '',
        email: '',
        receipt_time_begin: '',
        receipt_time_end: '',
        remark: '',
        id: '',
        type: 1,
      },
      gameOptions: [],
      gameNameOptions: [],
      applicateOptions: [],
      popupTitle: '',
      addData: {},
      addCheck: '',
      check: '',
      billVisible: false,
      receiptM2: false,
      receiptDeleteEnabled: false,
      canDelete: false,
      proofVisible: false,
      previewImages: [],
    };
  },
  computed: {
    addControl() {
      return this.popupTitle !== '添加';
    },
    isCompany() {
      return this.data.type === 2 || this.data.type === 3;
    },
    previewImageUrls() {
      return this.previewImages.map((item) => item.url);
    },
    billRules() {
      return {
        account: [{ required: true, message: '请输入玩家账号', trigger: 'blur' }],
        game_id: [{ required: true, message: '请选择游戏', trigger: 'change' }],
        game_server: [{ required: true, message: '请输入区服', trigger: 'blur' }],
        role_name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择开票类型', trigger: 'change' }],
        real_name: [{ required: true, message: '请输入开票人真实姓名或公司名称', trigger: 'blur' }],
        tax_no: [{ validator: this.validateTaxNo, trigger: 'blur' }],
        proof_images: [{ validator: this.validateProofImages, trigger: 'change' }],
        email: [{ type: 'email', message: '邮箱格式有误', trigger: 'blur' }],
        receipt_time_begin: [{ required: true, message: '请选择发票开始日期', trigger: 'change' }],
        receipt_time_end: this.check === 0
          ? [{ required: true, message: '请选择发票结束日期', trigger: 'change' }]
          : [],
      };
    },
  },
  created() {
    this.getBill();
    applicationListApi()
      .then((response) => {
        this.applicateOptions = response.data;
      })
      .catch(() => {});
    gameListApi()
      .then((response) => {
        this.gameOptions = response.data;
      })
      .catch(() => {});
  },
  methods: {
    createEmptyForm() {
      return {
        account: '',
        game_id: '',
        game_server: '',
        role_name: '',
        real_name: '',
        tax_no: '',
        proof_images: [],
        mobile: '',
        email: '',
        receipt_time_begin: '',
        receipt_time_end: '',
        remark: '',
        id: '',
        type: 1,
      };
    },
    validateTaxNo(rule, value, callback) {
      if (this.receiptM2 && this.isCompany && !String(value || '').trim()) {
        callback(new Error('请填写公司税号'));
        return;
      }
      callback();
    },
    validateProofImages(rule, value, callback) {
      if (!this.receiptM2 || !this.isCompany) {
        callback();
        return;
      }
      if (value != null && !Array.isArray(value)) {
        callback(new Error('证明材料格式有误'));
        return;
      }
      if (Array.isArray(value) && value.length > 5) {
        callback(new Error('证明材料最多上传5张'));
        return;
      }
      callback();
    },
    remoteMethod(query) {
      searchGameNameApi({ game_name: query })
        .then((response) => {
          this.gameNameOptions = response.data.data;
        })
        .catch(() => {});
    },
    addBill() {
      this.popupTitle = '添加';
      this.check = 1;
      this.data = Object.keys(this.addData).length ? JSON.parse(JSON.stringify(this.addData)) : this.createEmptyForm();
      this.billVisible = true;
      this.clearFormValidation();
    },
    closeDialog() {
      if (this.popupTitle === '添加' && (this.addCheck === 0 || this.addCheck === '')) {
        this.addData = JSON.parse(JSON.stringify(this.data));
      }
      if (this.popupTitle === '添加' && this.addCheck === 1) {
        this.addCheck = '';
        this.addData = {};
      }
      this.uploadingCount = 0;
      this.proofUploadCanSubmit = true;
    },
    search() {
      this.listQuery.page = 1;
      this.getBill();
    },
    resetAll() {
      this.listQuery = {
        page: 1,
        limit: 10,
        account: '',
        game_id: '',
        admin_id: '',
        real_name: '',
        email: '',
        create_time: '',
        order_field: 0,
        order_type: 0,
      };
      this.getBill();
    },
    edit(row) {
      this.popupTitle = '编辑';
      this.check = 0;
      getSingleBillApi(row).then((response) => {
        const detail = response.data.data;
        if (!detail || !detail.id) {
          this.$message.error('发票记录不存在或已删除');
          return;
        }
        this.data = {
          account: detail.account,
          game_id: Number(detail.game_id),
          game_server: detail.game_server,
          role_name: detail.role_name,
          real_name: detail.real_name,
          tax_no: detail.tax_no || '',
          proof_images: (detail.proof_images || []).map((item) => ({
            id: item.id,
            name: item.file_name,
            url: item.file_url,
            sort: item.sort_order,
          })),
          mobile: detail.mobile,
          email: detail.email,
          receipt_time_begin: detail.receipt_time_begin,
          receipt_time_end: detail.receipt_time_end,
          remark: detail.remark,
          id: detail.id,
          type: Number(detail.type),
        };
        this.billVisible = true;
        this.clearFormValidation();
      });
    },
    sortChange(column) {
      if (column.prop === 'created_at') {
        this.listQuery.order_field = 0;
      } else if (column.prop === 'total_money') {
        this.listQuery.order_field = 1;
      }
      this.listQuery.order_type = column.order === 'ascending' ? 1 : 0;
      this.listQuery.page = 1;
      this.getBill();
    },
    getBill() {
      this.listLoading = true;
      const query = Object.assign({}, this.listQuery);
      if (!this.receiptM2) {
        delete query.real_name;
        delete query.email;
      }
      getBillApi(query)
        .then((response) => {
          const result = response.data.data || {};
          this.receiptM2 = !!(result.capabilities && result.capabilities.receipt_m2 === true);
          this.canDelete = this.receiptM2 && result.can_delete === true;
          const rows = Array.isArray(result.data) ? result.data : [];
          this.tableData = rows.map((item) => ({
            ...item,
            billSection: `${item.receipt_time_begin} - ${item.receipt_time_end}`,
            total_money: Number(item.total_money),
          }));
          this.total = Number(result.total || 0);
        })
        .catch(() => {})
        .finally(() => {
          this.listLoading = false;
        });
    },
    remove() {
      this.billVisible = false;
    },
    sure() {
      if (this.uploadingCount > 0 || !this.proofUploadCanSubmit) {
        this.$message.warning('证明材料仍在上传或存在上传失败，请处理后再保存');
        return;
      }
      this.$refs.billForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const payload = this.buildPayload();
        const request = this.check === 1 ? addBillApi(payload) : submitSingleBillApi(payload);
        this.submitting = true;
        request
          .then((response) => {
            if (response.data.code === 200) {
              this.$message.success(response.data.message);
              this.addCheck = 1;
              this.billVisible = false;
              this.getBill();
            } else {
              this.$message.error(response.data.message);
            }
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
    buildPayload() {
      const payload = JSON.parse(JSON.stringify(this.data));
      if (!this.receiptM2) {
        delete payload.tax_no;
        delete payload.proof_images;
        return payload;
      }
      if (payload.type === 1) {
        payload.tax_no = '';
        payload.proof_images = [];
      } else {
        payload.proof_images = payload.proof_images.map((item, index) => ({
          name: item.name,
          url: item.url,
          sort: index + 1,
        }));
      }
      return payload;
    },
    deleteBill(row) {
      this.$confirm(
        '删除后该登记将从发票列表移除并释放登记区间，VIP 后台“开发票”标签仍会保留。确认删除吗？',
        '删除发票记录',
        { confirmButtonText: '删除', cancelButtonText: '取消', type: 'warning' }
      )
        .then(() => deleteBillApi(row.id))
        .then((response) => {
          if (response.data.code !== 200) {
            this.$message.error(response.data.message);
            return;
          }
          this.$message.success(response.data.message);
          if (this.tableData.length === 1 && this.listQuery.page > 1) {
            this.listQuery.page -= 1;
          }
          this.getBill();
        })
        .catch((error) => {
          if (error !== 'cancel' && error !== 'close') {
            this.$message.error('删除失败，请稍后重试');
          }
        });
    },
    previewProofImages(row) {
      getSingleBillApi(row).then((response) => {
        const detail = response.data.data || {};
        this.previewImages = (detail.proof_images || []).map((item) => ({
          id: item.id,
          url: item.file_url,
        }));
        if (!this.previewImages.length) {
          this.$message.info('暂无证明材料');
          return;
        }
        this.proofVisible = true;
      });
    },
    onUploadingChange(count) {
      this.uploadingCount = count;
    },
    onProofUploadStateChange(state) {
      this.proofUploadCanSubmit = !!(state && state.canSubmit);
    },
    clearFormValidation() {
      this.$nextTick(() => {
        if (this.$refs.billForm) {
          this.$refs.billForm.clearValidate();
        }
      });
    },
  },
};
</script>

<style scoped>
.filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}

.filter-form /deep/ .el-input,
.filter-form /deep/ .el-select {
  width: 180px;
}

.toolbar {
  display: flex;
  justify-content: flex-end;
  margin: 8px 0 20px;
}

.billHandle /deep/ .el-input,
.billHandle /deep/ .el-select,
.billHandle /deep/ .el-textarea {
  width: 420px;
  max-width: 100%;
}

.proof-preview {
  display: flex;
  flex-wrap: wrap;
}

.proof-preview /deep/ .el-image {
  width: 148px;
  height: 148px;
  margin: 0 12px 12px 0;
  border: 1px solid #ebeef5;
}
</style>
